import { render } from "./PackagesList.vue?vue&type=template&id=7a37ab82&scoped=true"
import script from "./PackagesList.vue?vue&type=script&lang=js"
export * from "./PackagesList.vue?vue&type=script&lang=js"

import "./PackagesList.vue?vue&type=style&index=0&id=7a37ab82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a37ab82"]])

export default __exports__